import React from "react";
import { Card, CardBody } from "reactstrap";

const DataCard = ({ label, value, defaultValue, subLabel, contentStyle = {} }) => (
  <Card className="mb-3 shadow-sm border border-secondary h-100 d-flex flex-column">
    <CardBody className="py-3 d-flex flex-column justify-content-between flex-grow-1">
      <div
        className="flex-grow-1 overflow-auto"
        style={{ ...contentStyle }}
      >
        <strong>{label}: </strong>
        <div className="text-muted">{value ?? defaultValue}</div>
      </div>
      {subLabel && (
        <div className="text-muted small mt-2">⏱ {subLabel}</div>
      )}
    </CardBody>
  </Card>
);

export default DataCard;
